__turbopack_context__.v({
  "listingsSeo": "listings-seo-module-scss-module__04TJVa__listingsSeo",
  "listingsSeo__isMapView": "listings-seo-module-scss-module__04TJVa__listingsSeo__isMapView",
  "listingsSeo_description": "listings-seo-module-scss-module__04TJVa__listingsSeo_description",
  "listingsSeo_title": "listings-seo-module-scss-module__04TJVa__listingsSeo_title",
});
